import { useId } from 'react';

interface Props {
  label: string;
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  error?: string;
  optional?: boolean;
  multiline?: boolean;
  autoFocus?: boolean;
}

const inputClass =
  'mt-1 block w-full rounded-lg border border-stone-300 dark:border-stone-600 bg-white dark:bg-[#242d28] px-3 py-2 text-sm text-stone-900 dark:text-stone-100 focus:outline-none focus:ring-2 focus:ring-moss-500';

export default function TreeSpeciesField({
  label,
  value,
  onChange,
  maxLength,
  error,
  optional = false,
  multiline = false,
  autoFocus = false,
}: Props) {
  const id = useId();
  const errorId = `${id}-error`;
  const shared = {
    id,
    className: inputClass,
    value,
    maxLength,
    autoFocus,
    'aria-invalid': Boolean(error),
    'aria-describedby': error ? errorId : undefined,
  };

  return (
    <div>
      <label htmlFor={id} className="text-sm font-medium text-stone-700 dark:text-stone-300">
        {label} {optional && <span className="text-stone-400">(optional)</span>}
      </label>
      {multiline ? (
        <textarea {...shared} rows={4} onChange={(e) => onChange(e.target.value)} />
      ) : (
        <input {...shared} onChange={(e) => onChange(e.target.value)} />
      )}
      {error && (
        <span id={errorId} className="mt-1 block text-xs text-red-600 dark:text-red-400">
          {error}
        </span>
      )}
    </div>
  );
}
